import { BoolQuestionDTO } from 'jobs/dtos/questions'
import { toBoolean } from 'utils/bool-util'
import QuestionViewModelBase, {
  QuestionViewModelPort,
} from '../QuestionViewModelBase'
import { action, computed, observable, makeObservable } from 'mobx'
import { QuestionValidationResult } from '../QuestionValidationResult'
import { QuestionInputValue } from '../input-value-types'

export interface BoolSettings {
  showErrorMessages: boolean
}

export const BoolSettings = {
  defaults: {
    showErrorMessages: false,
  } as BoolSettings,
}

export default class BoolQuestionViewModel extends QuestionViewModelBase<BoolQuestionDTO> {
  // Instantiating is key in mobx 6 if not done, the observable state will be lost because mobx 6 sucks.
  @observable answer?: boolean = undefined

  settings: BoolSettings = BoolSettings.defaults

  constructor(private boolQuestionView: QuestionViewModelPort) {
    super(boolQuestionView)

    makeObservable(this)
  }

  configure(settings: BoolSettings) {
    this.settings = settings
    return this
  }

  @computed
  get isAnswered(): boolean {
    return this.answer !== undefined
  }

  protected textAnswer(): string {
    return this.answer ? 'Yes' : 'No'
  }

  protected hydrateAnswer(answer: unknown): void {
    this.answer = answer === undefined ? undefined : toBoolean(answer)
  }

  @action.bound
  change(newValue: boolean) {
    this.answer = newValue
    this.notify()
  }

  protected serializeAnswer() {
    return this.answer
  }

  validate(): QuestionValidationResult {
    if (this.answer === undefined) {
      return QuestionValidationResult.failed(['Please pick one.'])
    }
    return QuestionValidationResult.ok()
  }

  toInputValue(): QuestionInputValue {
    return { type: 'BOOL', value: this.answer }
  }
}
